import { Component, inject } from '@angular/core';
import { PersonCategoryMappingBioForestService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PersonCategoryMappingBioForestCreateDto,
  PersonCategoryMappingBioForestDto,
  PersonCategoryMappingBioForestExcelDownloadDto,
  PersonCategoryMappingBioForestUpdateDto,
} from '../proxy/general/dtos/person-category-mapping-bio-forest';
import { PERSONCATEGORYMAPPINGBIOFOREST_CONFIG, PERSONCATEGORYMAPPINGBIOFOREST_FIELDS } from './person-category-mapping-bio-forest.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-person-category-mapping-bio-forest',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PersonCategoryMappingBioForestService, ConfirmationService],
  templateUrl: './person-category-mapping-bio-forest.html',
  styleUrl: './person-category-mapping-bio-forest.scss',
})
export class PersonCategoryMappingBioForest extends BaseCrudComponent<
  PersonCategoryMappingBioForestDto,
  PersonCategoryMappingBioForestCreateDto,
  PersonCategoryMappingBioForestUpdateDto,
  PersonCategoryMappingBioForestExcelDownloadDto
> {
  service = inject(PersonCategoryMappingBioForestService);
  config = PERSONCATEGORYMAPPINGBIOFOREST_CONFIG;
  fields = PERSONCATEGORYMAPPINGBIOFOREST_FIELDS;

  protected prepareUpdateDto(data: any, selected: PersonCategoryMappingBioForestDto): PersonCategoryMappingBioForestUpdateDto {
    return {
      personCategoryId: data.personCategoryId,
      resourceTypeId: data.resourceTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PersonCategoryMappingBioforest';
  }
}
